import Container from 'react-bootstrap/Container';
import { Header } from '../components/Header';
import { Footer } from '../components/Footer';
import { useMe } from '../lib/use-me';
import '../styles/page.scss';

export function Profile() {
  const me = useMe();

  return (
    <div className="x5-page">
      <Header />
      <main className="x5-page__body">
        <Container className="mt-4">
          <h2>Profile</h2>
          {me ? (
            <dl>
              <dt>Username</dt>
              <dd>{me.username}</dd>
              <dt>Organization</dt>
              <dd>{me.organization?.name ?? me.organizationId}</dd>
              {me.organization?.company && (
                <>
                  <dt>Company</dt>
                  <dd>{me.organization.company}</dd>
                </>
              )}
            </dl>
          ) : (
            <p>Profile details are unavailable.</p>
          )}
        </Container>
      </main>
      <Footer />
    </div>
  );
}
